import { Contacts } from "../components/Contacts";
import { WorkingHours } from "../components/WorkingHours";
import { Delivery } from "../components/Delivery";
import { Products } from "../components/Products";
import { Divider } from "../components/Divider";
import { DeliveryServices } from "../components/DeliveryServices";
import { UpdatesBanner } from "../components/UpdatesBanner";

export default function Home() {
  return (
    <>
      <Contacts position="top" />
      <WorkingHours />
      <UpdatesBanner />
      <DeliveryServices />
      {/* <Announce /> */}
      <Delivery />
      <Products />
      <Divider />
    </>
  );
}
